import type { FaireProductEntity } from "../../entity_types/product";

export const p_38pparzwby: FaireProductEntity = {
  token: "p_38pparzwby",
  type: "product",
  name: "Aquamarine Bezeled Necklace with Pave Diamond Gold Clasp. Pave Diamond Starburst Pendant",
  brandToken: "b_j8jk2k8849",
  brandName: "ILISSA MICHELE JEWELRY",
  imageUrl:
    "https://cdn.faire.com/fastly/ea4a339655cc9269a0189bd173188d0fcba76f42f411af5b89429e33456d3a51.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e2b46bf3a128fdf5649783e2306f328245e999a6b810d80819d96dc2720df8db.jpeg",
  ],
  priceDollars: 343.5,
  description:
    'A stunning combination of cool aquamarine and brilliant diamonds — this 30" Aquamarine Bezel Necklace comes with a matching Pave Diamond Starburst Pendant for a complete, show-stopping look. Available in silver bezel with two-tone clasp or gold bezel with gold clasp, it can be worn long or doubled for two distinct styles.\n\n * 30" necklace length \n * Available in silver bezel with two-tone clasp or gold bezel with gold clasp \n * Clasps are sterling silver, gold plated where applicable \n * Wear long or doubled \n * Includes matching pave diamond starburst pendant \nOne necklace, endless possibilities — a true best seller for good reason.\n',
  tags: [],
  msrpDollars: 687,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:16.662Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
